import axios from 'axios';

const axiosSend = async (url, file, setProgress) => {
  const config = {
    headers: {
      'Content-Type': file.type,
    },
    timeout: 90000,
    onUploadProgress(progressEvent) {
      // console.devLog.info('Progress event:', progressEvent);
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total,
      );
      // console.devLog.info(percentCompleted);
      setProgress(percentCompleted);
    },
  };
  // console.devLog.info('Axios url:', url);
  // console.devLog.info('Axios data:', data);
  try {
    const result = await axios
      .put(url, file, config)
      .then((res) => {
        console.devLog.info('axios send result:', res);
        return res;
      })
      .catch((err) => {
        console.devLog.info('axios send error:', err);
        throw new Error(err);
      });

    return result;
  } catch (e) {
    console.devLog.info('Axios error:', e);
    throw new Error(e);
  }
};

export default axiosSend;
